var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4053 2.04492C11.4723 0.827281 13.4756 1.59064 13.4756 3.20117V9.80078H15.9658C17.4333 9.80078 18.2376 11.4698 17.375 12.6094L17.2861 12.7178L9.7168 21.3154L9.71777 21.3164C8.65097 22.5356 6.64552 21.7721 6.64551 20.1611V13.5615H4.15625C2.64659 13.5615 1.84951 11.7827 2.83203 10.6484L2.83594 10.6445L10.4053 2.04492Z",
    fill: "white",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashicon);
export default __webpack_public_path__ + "static/media/flashicon.f6abd462f942f573807c7bda177b3cb8.svg";
export { ForwardRef as ReactComponent };